import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// COMPLETELY DISABLE EVERYTHING IN DEVELOPMENT
if (import.meta.env.DEV) {
  console.log('🚫 DEVELOPMENT MODE: Disabling ALL blocking mechanisms...');

  // Disable service workers completely
  if ('serviceWorker' in navigator) {
    // Unregister all existing service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
        console.log('✅ Service worker unregistered');
      }
    });

    // Prevent new service worker registration
    const _originalRegister = navigator.serviceWorker.register;
    navigator.serviceWorker.register = function () {
      console.log('🚫 Service worker registration blocked in development');
      return Promise.reject(new Error('Service worker blocked in development'));
    };
  }

  // Clear ALL caches
  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      return Promise.all(
        cacheNames.map((cacheName) => {
          console.log('🗑️ Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('✅ All caches cleared');
    });
  }

  // DON'T CLEAR LOCALSTORAGE - preserve cookie consent and all user preferences
  if ('localStorage' in window) {
    console.log('🔒 Preserving ALL localStorage data (including cookie consent)');
    console.log('📋 Current localStorage keys:', Object.keys(localStorage));

    // Don't clear localStorage - let cookie consent and other preferences persist
    // This prevents the cookie popup from appearing on every refresh
  }

  if ('sessionStorage' in window) {
    sessionStorage.clear();
    console.log('✅ Session storage cleared');
  }

  // Block any content blocking
  if ('contentBlocker' in window) {
    console.log('🚫 Content blocker disabled');
  }

  console.log('🎯 Development mode ready - no blocking should occur');
} else {
  // Production mode - normal service worker
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('✅ SW registered in production:', registration);
        })
        .catch((registrationError) => {
          console.log('❌ SW registration failed:', registrationError);
        });
    });
  }
}

createRoot(document.getElementById("root")!).render(<App />);
